import React from 'react';
import ReactDOM from 'react-dom';
import PreGameReminder from '../components/PreGameReminder/PreGameReminder';

const BARLOW_FAMILY = 'Barlow Condensed';

async function loadBarlowCondensed() {
    const faces = await Promise.all([
        document.fonts.load(`700 1px "${BARLOW_FAMILY}"`),
        document.fonts.load(`600 1px "${BARLOW_FAMILY}"`)
    ]);
    if (faces.some(f => !f.length)) {
        console.warn('[PreGameReminderService] Barlow Condensed not found, using fallback font.');
    }
}

const PreGameReminderService = {
    async init () {
        const node = document.getElementById('pregame-reminder-root');
        if (!node) return;

        try {
            await loadBarlowCondensed();
        } catch (err) {
            console.warn('[PreGameReminderService] Barlow Condensed failed to load, using fallback font.', err);
        }

        ReactDOM.render(<PreGameReminder />, node);
    }
};

export default PreGameReminderService;
